import React, { Component } from 'react';
import has from 'lodash/has';
import isFinite from 'lodash/isFinite';
import toNumber from 'lodash/toNumber';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';
import { ROUTE_CONNECT } from 'new/constants/pathnames';
import * as OLD_PATHS from 'js/constants/pathnames';
import ViewSchemaSpecsContainer from './ViewSchemaSpecsContainer';
import CreateSchemaSpecFormContainer from './CreateSchemaSpecFormContainer';

class SchemaSpecsDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayForm: false,
      specBeingEdited: null,
      formKey: 0,
    };

    this._handleFormSubmitted = this._handleFormSubmitted.bind(this);
    this._handleFormDismissed = this._handleFormDismissed.bind(this);

    this._handleFormLoadButtonClicked = this._handleFormLoadButtonClicked.bind(this);
  }

  _handleFormLoadButtonClicked(specBeingEdited = null) {
    this.setState({
      displayForm: true,
      specBeingEdited,
      formKey: this.state.formKey + 1,
    });
  }

  _handleFormDismissed() {
    this.setState({
      displayForm: false,
    });
  }

  _handleFormSubmitted() {
    this.setState({
      displayForm: false,
    });
  }

  render() {
    const { withHeader, onlyTableView } = this.props;
    let schemaSpecId = null;
    let displayContent = null;

    if (has(this.props, 'match.params.id')) {
      let schemaSpecIdNum = toNumber(this.props.match.params.id);
      if (isFinite(schemaSpecIdNum)) {
        schemaSpecId = schemaSpecIdNum;
      }
    }

    if (this.state.displayForm === true) {
      let isEditMode = this.state.specBeingEdited !== null;
      displayContent = (
        <CreateSchemaSpecFormContainer
          key={this.state.formKey}
          isEditMode={isEditMode}
          specBeingEdited={this.state.specBeingEdited}
          onFormSubmitted={this._handleFormSubmitted}
          onFormDismissed={this._handleFormDismissed}
          onFormLoadButtonClicked={this._handleFormLoadButtonClicked}
        />
      );
    } else {
      displayContent = (
        <ViewSchemaSpecsContainer
          withHeader={withHeader}
          onlyTableView={onlyTableView}
          schemaSpecId={schemaSpecId}
          onFormLoadButtonClicked={this._handleFormLoadButtonClicked}
        />
      );
    }

    return <>{displayContent}</>;
  }
}

SchemaSpecsDashboard.defaultProps = {
  withHeader: true,
  onlyTableView: false,
};

export const schemaSpecsDashboardScreenConfig = {
  screenName: 'SchemaSpecsDashboard',
  domain: 'integrate',
  pageTitle: 'Schema Templates',
  path: `${ROUTE_REDESIGN}${ROUTE_CONNECT}${OLD_PATHS.ROUTE_SCHEMA_SPECS}`,
  exact: true,
  defaultProps: {
    withHeader: false,
    onlyTableView: true,
  },
};

SchemaSpecsDashboard.screenConfig = schemaSpecsDashboardScreenConfig;

export default SchemaSpecsDashboard;
